import {
    getLiveDetails, postHangUp, getResetLiveDetails
  } from "../service/api";

export const ActionGetLiveDetails = () => async (dispatch) => {
    await getLiveDetails().then(function (value) {
      dispatch({
        type: "LIVE DETAILS",
        payload: value,
      });
    });
  };

  export const ActionHangUp = (data, callback) => async (dispatch) => {
    await postHangUp(data).then(function (value) {
      dispatch({
        type: "HANGUP",
        payload: value,
      });
      callback();
    });
  };

  export const ActionResetLiveDetails = () => async (dispatch) => {
    try {
      const value = await getResetLiveDetails();
      dispatch({
        type: "RESET_DETAILS",
        payload: value,
      });
      return value;
    } catch (error) {
      console.error("Error resetting live details:", error);
      throw error; 
    }
  };